import React, { useEffect } from "react";
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider } from "./contexts/AuthContext";
import Routes from "./Routes";
import GlobalMessages from "./components/GlobalMessages";
import { initializeEngagementTracking } from "./utils/userEngagementService";
import { initializeAnalytics } from "./utils/analyticsService";
import "./utils/debugStripe"; // Import debug utilities
import "./utils/debugSubscriptions"; // Import subscription debug utilities
import "./utils/testCreatePayment"; // Import create payment test utilities

function App() {
  useEffect(() => {
    // Initialize user engagement tracking
    initializeEngagementTracking();
    
    // Initialize PostHog analytics
    initializeAnalytics();
    
    // Handle OAuth callback directly if we're on the callback path
    if (window.location.pathname === '/auth/callback') {
      // Check if we have OAuth tokens in the URL hash
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      const accessToken = hashParams.get('access_token');
      
      if (accessToken) {
        // Redirect to dashboard after a short delay to let Supabase process the tokens
        setTimeout(() => {
          window.location.href = '/game-library-dashboard';
        }, 1000);
      } else {
        // No tokens found, redirect to login
        window.location.href = '/user-login';
      }
    }

    // Confirm debug functions are available
    setTimeout(() => {
      if (window.debugStripeIntegration) {
        console.log('✅ Debug functions successfully loaded and available globally');
      } else {
        console.warn('⚠️ Debug functions not found on window object');
      }
    }, 100);
  }, []);

  return (
    <AuthProvider>
      <GlobalMessages />
      <Routes />
      <Analytics />
    </AuthProvider>
  );
}

export default App;
